module.exports = __webpack_public_path__ + "static/media/achtertuin_3.1629d5c1.jpg";